import React, { useEffect } from 'react';
import Review from '../components/Review';
import { Box } from '@mui/material';

interface ReviewsPageProps {
}

const ReviewsPage: React.FC<ReviewsPageProps> = ({ }) => {
    useEffect(() => {
        window?.scrollTo({ top: 0, behavior: "smooth" })
    }, [])

    return (
        <Box>
            <Review />
        </Box>
    )
}

export default ReviewsPage;